const theme = {
  breakpoints: ['32em', '48em', '64em', '90em'],
  oniloBlue: '#27b0d4',
  oniloLightOrange: '#f6793d',
  oniloDarkOrange: '#f26521',
};

export default theme;
